<template>
	
	<div class="border-t my-1 border-color-gray-200 "></div>
	
</template>

<script>
export default {
	name: 'DropDownDivider',
	
	data(){
		return {

		}
	}
}
</script>
